<div class="auto-config-layer">
  <img [ngSrc]="getLayerIconByType(layer.ObjectType)" width="24" height="24" alt="layer_icon">
  <span class="layer-name">{{ layer.LayerName }}</span>
  <span class="source-layer-datasource-name" *ngIf="displayWithSourceName">({{ layer.DataSource }})</span>
</div>
